module.exports = __webpack_public_path__ + "img/active-4.1c7553a7.svg";